











































import { Component, Vue } from 'vue-property-decorator'
import { currenties } from '@/api/com'
import { currentUserBalance } from '@/api/transaction'
// import { downloadFile } from '@/utils/tool'

@Component({
  name: 'Balance',
  components: {}
})
export default class Balance extends Vue {
  show = false

  // 系统所有的币种
  systemList: any[] = []

  // 用户的币种信息
  userList: any[] = []

  // 系统用户信息
  get userInfo () {
    return this.$store.state.User.userInfo
  }

  // 是否隐藏充值
  get hidePay () {
    // 系统 6292176 需求 9730
    return ![6292176].includes(this.userInfo.parentMchId)
  }

  // 计算属性获取CNY币种余额
  get cnyGuarantee (): string {
    const cnyItem = this.userList.find(item => item.currencyCode === 'CNY')
    return cnyItem?.accountGuarantee ? this.toDecimal2(cnyItem.accountGuarantee / 100) : '0.00'
  }

  // 是否显示保证金充值按钮 >= 3千隐藏
  get isShowGuaranteeBtn (): boolean {
    const cnyItem = this.userList.find(item => item.currencyCode === 'CNY')
    return cnyItem?.accountGuarantee < 300000
  }

  // 获取最终的货币信息
  get list (): any[] {
    const arr:any[] = []
    for (let i = 0; i < this.systemList.length; i++) {
      const item = this.systemList[i]
      for (let j = 0; j < this.userList.length; j++) {
        const el = this.userList[j]
        if (el.currencyCode === item.code) {
          if (!el.accountBalance) {
            item.accountBalance = ''
            break
          }
          // const a = el.accountBalance.toString()
          // item.accountBalance = a.slice(0, a.length - 2) + '.' + a.slice(a.length - 2)
          item.accountBalance = el.accountBalance / 100
          item.accountBalance = this.toDecimal2(item.accountBalance)
          break
        }
      }
      arr.push(item)
    }
    // if (this.show) return arr
    return arr
  }

  // 保留两位小数
  toDecimal2 (x: number | string): string {
    let num: number

    if (typeof x === 'string') {
      num = parseFloat(x)
    } else {
      num = x
    }

    if (isNaN(num)) {
      return '0.00' // 返回默认值，避免 false
    }

    num = Math.round(num * 100) / 100

    const s = num.toFixed(2) // 使用 toFixed 确保两位小数
    return s
  }

  // 获取所有的币种信息
  async getCurrenties (): Promise<void> {
    const res = await currenties()
    if (res) {
      this.systemList = res
    }
  }

  // 获取当前用户的币种信息
  getCurrentUserBalance (): void {
    currentUserBalance()
      .then((res: any) => {
        if (res) {
          this.userList = res
        }
      })
  }

  // 去充值页面
  goRecharge (code: string, isEarnest = false): void {
    let path = `/recharge?currency=${code}`
    if (isEarnest) path = `/recharge?currency=${code}&isEarnest=1`
    this.$router.push({
      path: path
    })
  }

  // 点击凭证下载
  clickVoucher (): void {
    // clickVoucher
    console.log('点击凭证下载')
    console.log(this.userList)
    this.userList.forEach(item => {
      if (item.guaranteeMoneyVoucher) {
        window.open(item.guaranteeMoneyVoucher)
        // downloadFile(item.guaranteeMoneyVoucher)
      }
    })
  }

  // 去提现页面
  goCash (item: any): void {
    this.$router.push({
      path: `/cash?currency=${item.code}&symbol=${item.symbol}`
    })
  }

  mounted (): void {
    this.getCurrenties()
    this.getCurrentUserBalance()
  }
}
